var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.346 30.667h20.308a4.512 4.512 0 004.513-4.513V5.869h-5.641V1.334H1.834v24.82a4.512 4.512 0 004.512 4.513zM4.09 26.154V3.59h19.18v22.553h2.256V8.125h3.384v18.029a2.263 2.263 0 01-2.256 2.256H6.346a2.263 2.263 0 01-2.256-2.256zM20.5 8H7.167v2.667H20.5V8zM7.167 13.334H20.5V16H7.167v-2.666zm0 5.333H20.5v2.666H7.167v-2.666z",
    fill: "#54822B"
  })));
}

export default SvgIconReceipt;